import { api } from '../utils/data-utils';

export type ManagedOption = {
  id: string;
  version: number;
  value: string;
  retired: string | null;
  aliases: string[];
  metadata: { key?: string; crossGovernmentDefault?: boolean };
};
export type ManagedField = {
  field: string;
  title: string;
  revision: number;
  options: ManagedOption[];
  runningJob?: string | null;
};
export type CorrectionJob = {
  last_error?: string;
  sk: string;
  status: 'counting' | 'ready' | 'running' | 'complete';
  old_value: string;
  value: string;
  revision: number;
  drafts: number;
  submitted: number;
  legacy?: number;
  updated_answers: number;
};

export async function managedOptionsRequest<T>(
  token: string,
  tenant: string,
  body?: Record<string, unknown>,
  query = '',
): Promise<T> {
  const response = await api(token, `/managed-options/${encodeURIComponent(tenant)}${query}`, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', 'X-Tenant': tenant },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  return response.json() as Promise<T>;
}
